import { parseOptionalFiniteNumber } from "./csvNumber";
import { formatCurrencyUsd } from "./financeDisplay";

/**
 * Optional FY money on a SOP row. Empty → 0; must be finite and ≥ 0.
 * @param {unknown} raw
 * @param {string} fieldName
 * @returns {{ ok: true, value: number } | { ok: false, error: string }}
 */
export function parseSopMoneyField(raw, fieldName) {
  if (raw === undefined || raw === null || String(raw).trim() === "") {
    return { ok: true, value: 0 };
  }
  return parseOptionalFiniteNumber(raw, {
    min: 0,
    defaultIfEmpty: 0,
    fieldName,
  });
}

/**
 * Cost per kid hour = expenses / hours. Null when hours are missing or 0.
 * @param {unknown} expenses
 * @param {unknown} hours
 * @returns {number | null}
 */
export function computeCostPerKidHour(expenses, hours) {
  const exp = Number(expenses);
  const hrs = Number(hours);
  if (!Number.isFinite(exp) || !Number.isFinite(hrs) || hrs <= 0) return null;
  return exp / hrs;
}

/** USD rate, or em dash when the rate cannot be computed. */
export function formatCostPerKidHour(expenses, hours) {
  const rate = computeCostPerKidHour(expenses, hours);
  if (rate == null) return "—";
  return formatCurrencyUsd(rate);
}
